/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import React from 'react'
import KeyStatsV2 from '../../Widgets/InStockV2/KeyStatV2'
import INDStocksInsights from '../../Widgets/INDStocksInsights'
import TimelineWidget from '../../Widgets/TimelineWidget'
import WhatExpertsSayWrapper from '../../Widgets/WhatExpertsSaysWrapper'
// import InsightsWidget from '../../Widgets/InsightsWidget'
import Forecast from '../../Widgets/Forecast'
import { ICategoryFnO } from '../../FnO/types/options-chain'
import { generateStockFaqsV2 } from '../../Utils/generateStockFaqs'
import { TAssetDetailsData } from '@/components/Stocks/Widgets/types'
import { IHeaders } from '@/components/Stocks/Pages/INStockDetailPage/types'
import NewPerformance from '@/stories/components/Common/PerformanceWidget'
import PeerComparisonNew from '@/stories/components/INStocksDetail/PeerComparisonNew'
import MFHoldings from '@/stories/components/INStocksDetail/MFHoldings'
import CompanyInfoWrapper from '@/components/INDStocks/DetailPage/CompanyInfoWrapper'
import Valuations from '@/stories/components/INStocksDetail/Valuations'
import FnO from '@/components/INDStocks/DetailPage/FnO'
import {
  TStrapiV4CommonRichTextEditorWidget,
  TStrapiV4PageType,
  TStrapiV4SectionFAQsWidget,
} from '@/stories/strapi-4/common-types'
import { StrapiV4SectionFAQs } from '@/stories/strapi-4/widget-components/faqs-section/faqs-section'
import INStocksOverview from '@/stories/components/INStocksDetail/INStocksOverview'
import RisingPatternWidget from '@/stories/components/INStocksDetail/RisingPatternWidget'
import Infographics from '@/components/Common/Infographics'
import CorporateAnnouncements from '@/components/USStocks/USStocksChildPage/corporate-annoucements'
import ManagementTeam from '@/components/INDStocks/DetailPage/ManagementTeam'
import IndicesInclusion from '@/components/INDStocks/DetailPage/IndicesInclusion'
import TransposedDataTable from '@/stories/components/DetailPage/TransposedDataTable'
import CardsListingV1 from '@/revamp/pods/us-stocks/l2/components/widgets/cards-listingV1'
import { RUPEE_SYMBOL } from '@/root/constants'
import { SectionWrapper } from '@/components/ScrollAwareV2/SectionWrapper'
import { TRelatedBlogs } from '@/root/utils/articles/types'
import RelatedBlogs from '@/components/Common/relatedBlogs'

const StockDetailLoggedOutV1 = (
  props?: TAssetDetailsData & {
    stockApiLoading: boolean
    isMobile: boolean | null
    headers: IHeaders
    strapiApiResponse?: TStrapiV4PageType | null
    fnoApiData?: ICategoryFnO | null
    showFNO: boolean
    inStocksRelatedBlogs: TRelatedBlogs | null
  },
) => {
  const {
    catalog = {},
    graph,
    isMobile,
    stockApiLoading,
    headers,
    metadata,
    strapiApiResponse,
    market_status = {},
    fnoApiData,
    showFNO,
    inStocksRelatedBlogs,
  } = props ?? {}

  const strapiFaqSection = strapiApiResponse?.data.attributes.content.find(
    el => el.__component === 'widgets.faqs-section',
  ) as TStrapiV4SectionFAQsWidget | null | undefined

  const strapiFaqs = strapiFaqSection?.faq_section ?? null

  const strapiAboutSection = strapiApiResponse?.data.attributes.content.find(
    el => el.__component === 'widgets.rich-text-editor',
  ) as TStrapiV4CommonRichTextEditorWidget | undefined

  const strapiAboutContent = strapiAboutSection?.rich_text_html

  const {
    entity_basic = {},
    entity_stats = {},
    stock_details,
    linked_collections = [],
  } = catalog
  const { live_price = '', performance = '' } = entity_stats
  const {
    short_name = '',
    ind_key = '',
    socket_path = '',
    exchange = '',
    name = '',
  } = entity_basic

  const { nudge_info } = metadata ?? {}

  const {
    research: entityDetailsResearch,
    analyst_forecast,
    stock_peers,
    company_details,
    brands_data,
    mutual_fund_holdings,
    news_items,
    // entity_news_card,
    insights_data,
    valuations,
    linked_indexes = [],
    management_data = [],
    technical_trend,
    ta_path,
    fundamental_data = {},
    interest_data = [],
    sp,
    pnl,
    cf,
  } = stock_details ?? {}
  const { consensus = {} } = analyst_forecast ?? {}

  const { infographics, corp_announcements } = entityDetailsResearch ?? {}

  const last_updated = entity_stats.last_updated_v2 ?? entity_stats.last_updated

  const stockData = {
    ...entity_basic,
    companyCode: entity_basic.ind_key,
    percent_change: entity_stats.day_change_percentage,
    last_updated,
    ...graph,
    chartData: graph?.candles ?? [],
    live_price,
    fallback: '',
    trading_symbol: entity_basic.symbol ?? ind_key,
    linked_collections,
    day_change: entity_stats.day_change,
    isMarketOpen: market_status?.current_market_status !== 'close',
  }

  const faqs = generateStockFaqsV2({
    ...entity_basic,
    ...entity_stats,
    ...performance,
    ...stock_details,
    market_status,
  })

  const faqSection = {
    heading: strapiFaqs?.heading ?? `FAQs`,
    faqs: [...faqs, ...(strapiFaqs?.faqs ?? [])],
  }

  const pnlQuarterly = pnl?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'quarterly',
  )
  const pnlAnnual = pnl?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'annual',
  )

  return (
    <div className="flex w-full flex-col gap-y-16">
      <SectionWrapper id="share-price">
        <INStocksOverview
          {...stockData}
          firebase_path={socket_path}
          graphLoading={!!stockApiLoading}
          isMobile={isMobile}
          headers={headers}
          metadata={metadata}
          isStocks={true}
          showLoginWidget={true}
          exchange={exchange}
        />
        {nudge_info?.title && <RisingPatternWidget nudge_info={nudge_info} />}
      </SectionWrapper>

      <SectionWrapper id="performance">
        {performance && (
          <NewPerformance
            {...performance}
            {...entity_stats}
            heading={`${short_name} Stock Performance`}
            marketDataHeading={`${short_name} share price movements today`}
            returnsHeading={`${short_name} Historical Returns`}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="fundamentals">
        {!!stock_peers?.length && (
          <KeyStatsV2
            stats={stock_peers[0]}
            company_name={short_name}
            technical_trend={technical_trend}
            ta_path={ta_path}
            fundamental_data={fundamental_data}
            industry_pe_ratio={valuations?.pe_ratio?.industry?.ratio}
            last_updated={last_updated}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="valuation">
        {!!valuations && (
          <Valuations
            data={valuations}
            name={short_name}
            last_updated={last_updated}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="peers">
        {!!stock_peers?.length && (
          <PeerComparisonNew
            data={stock_peers}
            ind_key={ind_key}
            heading={
              stock_peers.length === 1
                ? `${short_name} stock Key Stats`
                : `${name} vs Peer Comparison`
            }
            short_name={short_name}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="analyst-recommendation">
        {consensus?.sentiment && (
          <WhatExpertsSayWrapper
            consensus={consensus}
            company_name={short_name}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="target-price">
        {analyst_forecast && (
          <Forecast
            {...analyst_forecast}
            compnany_name={short_name}
            live_price={`${RUPEE_SYMBOL}${live_price}`}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="sentiment">
        {!!interest_data.length && (
          <CardsListingV1
            widgetData={{
              d: {
                list: interest_data,
                he: `${short_name} Stock’s Investor Sentiment and Interest`,
              },
            }}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="pnl">
        {!!pnlQuarterly && (
          <TransposedDataTable
            details={{
              contents: [pnlQuarterly],
              display_name: `${name} Quarterly Profit & Loss`,
              display_subtitle: `Figures in Rupees Crores`,
            }}
          />
        )}
        {!!pnlAnnual && (
          <TransposedDataTable
            details={{
              contents: [pnlAnnual],
              display_name: `${name} Annual Profit & Loss`,
              display_subtitle: `Figures in Rupees Crores`,
            }}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="cf">
        {!!cf?.contents?.length && (
          <TransposedDataTable
            details={{
              ...cf,
              display_name: `${name} Cash Flow`,
              display_subtitle: `Figures in Rupees Crores`,
            }}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="shareholding">
        {!!sp?.contents?.length && (
          <TransposedDataTable
            details={{
              ...sp,
              display_name: `${short_name} Stock Shareholding Pattern`,
              display_subtitle: `Numbers in percentages`,
            }}
          />
        )}
        {!!mutual_fund_holdings?.length && (
          <MFHoldings
            sectionHeading={`Mutual Funds that own ${short_name} Stock`}
            subheading={`Check out the Mutual Funds with significant holdings in ${short_name}.`}
            data={mutual_fund_holdings}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="corp-action">
        {corp_announcements && (
          <CorporateAnnouncements
            {...corp_announcements}
            company_name={short_name}
            subheading={`View detailed summary of the earnings and dividend history of ${short_name}.`}
            containerClassName="!p-0"
            headingClassName="pb-6 border-b-[0.5px] w-full "
            heading="Corporate Actions"
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="blogs-news">
        {!!inStocksRelatedBlogs?.length && (
          <RelatedBlogs
            heading={`Latest Blogs about ${short_name}`}
            relatedBlogs={inStocksRelatedBlogs}
            isMobile={isMobile}
          />
        )}

        {news_items?.news_timelines && (
          <TimelineWidget
            heading={`${short_name} News & Key Events`}
            {...news_items.news_timelines}
            minwidth="lg:min-w-[57%] xl:min-w-[32%]"
            isMobile={false}
            itemClassName="!m-0"
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="indices">
        {!!linked_indexes?.length && (
          <IndicesInclusion
            linked_indexes={linked_indexes}
            heading={short_name}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="insights">
        {!!insights_data && (
          <INDStocksInsights
            data={insights_data}
            showDesc={true}
            itemClassName="!mb-0"
          />
        )}
        {infographics?.heading && <Infographics {...infographics} />}
      </SectionWrapper>

      {/* {entity_news_card?.heading && (
        <InsightsWidget
          {...entity_news_card}
          heading={`${short_name} News & Key Events`}
          subheading={`Latest 30 days news and events in one place to help you make informed investing decisions in ${short_name}.`}
          minwidth="lg:min-w-[57%] xl:min-w-[32%]"
          pod="stocks"
          className="!p-0"
          headingClassName="lg:text-2xl"
          headerClassName="!pb-6 mb-6 !border-b-[0.5px] w-full "
          itemClassName="!m-0"
        />
      )} */}

      <SectionWrapper id="futures-options">
        {showFNO && (
          <FnO
            isStocks={true}
            short_name={entity_basic.short_name ?? entity_basic.name ?? ''}
            fnoApiData={fnoApiData}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="company-info">
        {company_details && (
          <CompanyInfoWrapper
            company_details={company_details}
            name={name}
            full_name={entity_basic.name}
            brands_data={brands_data}
            strapiAboutSection={strapiAboutContent}
          />
        )}

        {!!management_data.length && (
          <ManagementTeam data={management_data} short_name={short_name} />
        )}
      </SectionWrapper>

      <SectionWrapper id="faqs">
        {!!faqSection.faqs.length && (
          <StrapiV4SectionFAQs
            faq_section={faqSection}
            variant="v1"
            addFontSize="size-24"
          />
        )}
      </SectionWrapper>
    </div>
  )
}

export default StockDetailLoggedOutV1
